import React from 'react';
import GEntity from "./../GEntity";
import Constants from "./../../constants/Constants";
import bubble from '../../../media/images/icons/bubble-left.png';

class Player extends GEntity {

    constructor(gameCtx, entityIndex, args) {
        super(gameCtx, entityIndex, args);

        this.turnStatus = Constants.TURN_STATUS_START;
        this.outstandingCard = null;
        this.chosenCard = null;
        this.enemyChosenCard = null;
        this.includeType = { viType: [], cb: null };
        this.excludeCards = { exList: [], cb: null };
        this.standInEntities = [];
        this.score = 0;

        this.overridePlay = this.overridePlayDefault = { override: false, singleTimeUse: false, fn: null };
        this.overrideAfterOnAfterPlayerGetCardFromNewPileOrUsedPile = false;
    }

    resetSelectedProperties = () => {
        this.outstandingCard = null;
        this.chosenCard = null;
        this.enemyChosenCard = null;
        this.includeType = { viType: [], cb: null };
        this.excludeCards = { exList: [], cb: null };
        this.lastReceivedCards = [];
        this.waitingEntities = [];
        this.standInEntities = [];
    }

    endTurn = () => {
        // End turn for entity is launched
    }

    informTimesUp = async () => {
        let text = <div className="popup-text interval-popup-text">נגמר הזמן!<br />השתדל להיות מהיר יותר בתור הבא</div>;
        this.addPopupWithInterval(text);
        await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);
        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
    }

    isTimeForActionCardsEventsUp = () => {
        return this.gameCtx.gameTimerRef.current.state.tSeconds > Constants.MIN_SECONDS_BEFORE_UNABLE_ACTION_CARDS_EVENTS;
    }

    levelToSixCards = async () => {
        let diff = this.cards.length - Constants.TOTAL_CARDS_IN_PLAYER_HAND;
        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                this.chooseRandCard(true, true);
                await this.gameCtx.moveCard(this.entityIndex, Constants.USED_PILE_INDEX, this.chosenCard, true, true);
            }

            return;
        }

        if (diff < 0) {
            await this.getCardsFromNewPile(Math.abs((diff)));
        }
        return;
    }

    onAfterCardThrownFromPlayerToUsedPile = async (card) => {
        await card.ref.current.onAfterCardThrownFromPlayerToUsedPile();
    }

    onAfterPlayerGetCardFromNewPileOrUsedPile = async (card) => {
        await card.ref.current.onAfterPlayerGetCardFromNewPileOrUsedPile(card, this.entityIndex);
    }

    handleStandOutCard = (chosenCard, isScaleUpAtStandOut = true) => {
        if (this.standInEntities.length > 0) {
            this.standInEntities.forEach(entity => entity.standInToPrevStandOutCard());
        }

        this.standInToPrevStandOutCard();
        this.standOutCard(chosenCard, isScaleUpAtStandOut);
    }

    standOutCard = (cardObj, isScaleUpAtStandOut = true) => {
        const DISTANCE = 20;

        let pos = cardObj.ref.current.getPos()
        let degForTri = this.degreesToRadians(pos[2])
        cardObj.ref.current.changePos(
            pos[0] + (DISTANCE * Math.sin(degForTri)),
            pos[1] - (DISTANCE * Math.cos(degForTri)),
            pos[2],
            this.cardSideShown,
            isScaleUpAtStandOut, 
            0.2,
            this.cards.length + 1);
    }

    standInToPrevStandOutCard = () => { // Make sure that the player has this.outstandingCard
        if (this.outstandingCard === null) { return }

        let index = this.getCardIndexInHand(this.outstandingCard);
        if (index === -1) {
            console.log("ERROR: index of card is -1");
            return;
        }

        let [left, top, rotDeg, cardSideShown, layer] = this.getCardCoordsByIndex(this.outstandingCard, index);
        this.outstandingCard.ref.current.changePos(left, top, rotDeg, cardSideShown, false, 0.1, layer);
    }

    subscribePlayMethod = (playMethod, singleTimeUse = false, overridePlay = false) => {
        if (typeof playMethod != "function") {
            console.log("ERROR: subscribePlayMethod has failed because playMethod is not a function");
            return;
        }
        this.overridePlay = { override: overridePlay, singleTimeUse: singleTimeUse, fn: playMethod };
    }

    handleChooseCardEvent = async (chosenCard, isExludeCards = false, IsIncludeType = false, cb = null, isScaleUpAtStandOut = true) => {
        if (!isExludeCards) {
            this.excludeCards = { exList: [], cb: null };
        }

        if (!IsIncludeType) {
            this.includeType = { viType: [], cb: null };
        }

        if (this.outstandingCard !== null && chosenCard.ref.current.id === this.outstandingCard.ref.current.id) {
            //Card is double selected, moving selected card to Used Pile

            if (cb && typeof cb === "function") {
                await cb(chosenCard);
            }
            this.unsubscribeEventToCards();
            this.chosenCard = chosenCard;
            this.resolvePlayer(0);
        }

        else { //Card is not the same, repeating process
            if (this.excludeCards !== null && this.excludeCards.cb && typeof this.excludeCards.cb === "function" && this.excludeCards.exList.length > 0) {
                let forbiddenCards = this.excludeCards.exList.filter(card => card.ref.current.id === chosenCard.ref.current.id);
                if (forbiddenCards.length > 0) {
                    this.excludeCards.cb(this.outstandingCard);
                    return;
                }
            }

            if (this.includeType !== null && this.includeType.cb && typeof this.includeType.cb === "function" && this.includeType.viType.length > 0) {
                if (!this.includeType.viType.includes(chosenCard.ref.current.type)) {
                    this.includeType.cb(this.outstandingCard);
                    return;
                }
            }

            this.handleStandOutCard(chosenCard, isScaleUpAtStandOut);
            this.outstandingCard = chosenCard;
        }
    }

    getCardIndexInHand = (cardObj) => {
        let index = -1;
        this.cards.forEach((card, i) => {
            if (cardObj.ref.current.id === card.ref.current.id) {
                index = i;
            }
        });
        return index;
    }

    addBubbleOnBottomPlayer = () => {
        return;
    }

    addPopupWithEvent = (text, btnAText = "כן", btnBText = "לא") => {
        const instructionsPopup =
            <div className="popup-box" key={Constants.ELEMENT_CARD_POPUP}>
                <img draggable="false" src={bubble} alt="explain_popup" className="bubble"/>
                <div className="popup-content">
                    {text}
                    <div className="popup-buttons">
                        <div className="popup-button" onClick={() => this.handlePopupClick(true, Constants.ELEMENT_CARD_POPUP)}>
                           {btnAText} 
                        </div>
                        <div className="popup-button" onClick={() => this.handlePopupClick(false, Constants.ELEMENT_CARD_POPUP)}>
                            {btnBText}
                        </div>
                    </div>
                </div>
            </div>;

        this.gameCtx.elementsHandler.addElement(Constants.ELEMENT_CARD_POPUP, instructionsPopup);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_BUBBLE);

        this.setPopupEvent();
        return this.popupEvent;
    }

    addPopupWithInterval = (text) => {
        const RATIO_BETWEEN_BUBBLE_HEIGHT_AND_TEXT = 0.10;
        const BUBBLE_HEIGHT = this.getBubbleHeight();

        let bubbleTextStyle = {
            boxSizing: 'border-box',
            padding: `${BUBBLE_HEIGHT * RATIO_BETWEEN_BUBBLE_HEIGHT_AND_TEXT}vh`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            verticalAlign: 'middle',
            lineHeight: `${BUBBLE_HEIGHT / 3}vh`
        }

        const instructionsPopup =
            <div className="popup-box" key={Constants.ELEMENT_CARD_POPUP}>
                <img src={bubble} alt="explain_popup" className="bubble" draggable="false"/>
                <div className="popup-content" style={bubbleTextStyle}>
                    {text}
                </div>
            </div>;

        this.gameCtx.elementsHandler.addElement(Constants.ELEMENT_CARD_POPUP, instructionsPopup);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_BUBBLE);
    }

    handlePopupClick = (val, key) => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        this.popupVal = val;
        this.resolvePopupEvent(val);
    }

    hasCardFromType = (cardType) => {
        let cards = this.cards.filter(card => card.ref.current.type === cardType);
        if (cards.length > 0) {
            return true;
        }
        return false;
    }

    getGrayTitlePlate = (key, style) => {
        const titlePlate =
            <div key={key} className="title-plate-parent">
                <img src={require("./../../../media/images/icons/gray-plate.png")} alt="" className="title-plate" draggable="false" style={style}></img>
                {this.getText()}
            </div>;
        return titlePlate
    }

    getGoldTitlePlate = (key, style) => {
        const titlePlate =
            <div key={key} className="title-plate-parent">
                <img src={require("./../../../media/images/icons/gold-plate.png")} alt="" className="title-plate" draggable="false" style={style}></img>
                {this.getText()}
            </div>;
        return titlePlate
    }

    getText = () => {
        const RATIO_BETWEEN_PLATE_HEIGHT_AND_TEXT = 0.5;
        let text = this.getName()
        let plateStyle = this.getTitlePlateStyle()
        let bottomNumber = plateStyle.bottom.substring(0, plateStyle.bottom.length - 2)
        let movingHeight = (Constants.TITLE_DIMENSION / 100) * this.sHeight
        let bottom = Number(bottomNumber) + movingHeight
        let textStyle = {
            fontSize: `${Constants.TITLE_DIMENSION * RATIO_BETWEEN_PLATE_HEIGHT_AND_TEXT}vh`,
            position: 'absolute',
            bottom: `${bottom}px`,
            left: plateStyle.left,
            height: plateStyle.height,
            width: plateStyle.width,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            zIndex: 3
        }

        const textdiv =
            <div className="text" style={textStyle}>{text}</div>
        return textdiv
    }

    addTitlePlateMarkup = () => {
        this.gameCtx.elementsHandler.addElement(this.getTitlePlateKey(), this.getGoldTitlePlate(this.getTitlePlateKey(), this.getTitlePlateStyle()))
    }

    removeTitlePlateMarkup = () => {
        this.gameCtx.elementsHandler.addElement(this.getTitlePlateKey(), this.getGrayTitlePlate(this.getTitlePlateKey(), this.getTitlePlateStyle()))
    }

    chooseRandCard = (isExludeCards = false, IsIncludeType = false) => {
        let cards = this.getCards();
        let card = this.pickRandCardFromArr(cards, isExludeCards, IsIncludeType);
        this.chosenCard = card;
    }

    standOutToRandCard = (isExludeCards = false, IsIncludeType = false) => {
        let cards = this.getCards();
        let card = this.pickRandCardFromArr(cards, isExludeCards, IsIncludeType);
        this.outstandingCard = card;
    }

    pickRandCardFromArr = (cardsArr, isExludeCards = false, IsIncludeType = false) => {
        let min = 0;

        if (!isExludeCards) {
            this.excludeCards = { exList: [], cb: null };
        }

        if (!IsIncludeType) {
            this.includeType = { viType: [], cb: null };
        }

        if (this.includeType.viType.length > 0) {
            cardsArr = cardsArr.filter(card => this.includeType.viType.includes(card.ref.current.type));
        }

        if (this.excludeCards.exList.length > 0) {
            cardsArr = cardsArr.filter(card => !this.excludeCards.exList.includes(card));
        }

        let max = cardsArr.length - 1;
        let randIndex = Math.floor(Math.random() * (max - min + 1)) + min;

        return cardsArr[randIndex];
    }

    chooseEnemyCard = (isExludeCards = false, IsIncludeType = false) => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let entities = this.gameCtx.gameSeqHandler.getAllCurrentEntityEnemies();
        let cards = [];
        for (let i = 0; i < entities.length; i++) {
            let eCards = entities[i].getCards();
            cards = cards.concat(eCards);
        }

        let card = cEntity.pickRandCardFromArr(cards, isExludeCards, IsIncludeType);

        cEntity.enemyChosenCard = card;

        let enemyEntity = cEntity.enemyChosenCard.ref.current.getOwner();

        enemyEntity.standOutCard(card);

        return enemyEntity;
    }

    informWinning = () => {
        // informWinning, this.score
    }

    informLosing = () => {
        // informLosing", this.score
    }
}

export default Player;